module.exports = __webpack_public_path__ + "static/media/29COICT4.5474ac74.jpg";